module.exports = __webpack_public_path__ + "static/pixel_text-c66d20c3513bf8080872fceea6d6981f.svg";